import { ViewCancelForm } from '@actions/novaOrdemActions';
import { useAppDispatch, useAppSelector } from '@config/reduxStore';
import { CancelarTransferencia } from '@services/api/api.transferencia';
import { Form, Input, Modal } from 'antd';

type FormData = {
  motivo: string;
};

function CancelTransferenciaModal() {
  const dispatch = useAppDispatch();
  const { cancelForm } = useAppSelector((state) => state.novaOrdem);
  const cancelarTransferencia = CancelarTransferencia();
  const [form] = Form.useForm<FormData>();
  const handleSubmit = (values: FormData) => {
    if (cancelForm.replace) {
      cancelarTransferencia.mutate({ id: cancelForm.id, motivo: values.motivo, replaced: true, cod: cancelForm.cod });
    } else
      cancelarTransferencia.mutate({ id: cancelForm.id, motivo: values.motivo, replaced: false, cod: cancelForm.cod });
  };
  return (
    <Modal
      open={cancelForm.visible}
      title="Razão do cancelamento/substituição"
      onCancel={() => {
        dispatch(ViewCancelForm({ id: null, view: false, replace: false, cod: null }));
      }}
      okButtonProps={{ loading: cancelarTransferencia.isLoading }}
      onOk={() => form.submit()}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item rules={[{ required: true, message: 'Campo obrigatório' }]} name="motivo">
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
}
export default CancelTransferenciaModal;
